// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/settings/v1/branding.proto" (package "c1.api.settings.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { FieldMask } from "../../../../google/protobuf/field_mask";
import { SrcSet } from "../../assets/v1/images";
/**
 * Public API view of a branding image with responsive sources.
 *
 * @generated from protobuf message c1.api.settings.v1.BrandingImage
 */
export interface BrandingImage {
    /**
     * @generated from protobuf field: string src = 1
     */
    src: string;
    /**
     * @generated from protobuf field: c1.api.assets.v1.SrcSet src_set = 2
     */
    srcSet?: SrcSet;
}
/**
 * Editable branding settings (no asset versions in request/response).
 *
 * @generated from protobuf message c1.api.settings.v1.BrandingSettings
 */
export interface BrandingSettings {
    /**
     * @generated from protobuf field: bool enabled = 1
     */
    enabled: boolean;
    /**
     * @generated from protobuf field: string display_name = 2
     */
    displayName: string;
}
/**
 * Complete branding configuration with all assets and settings
 *
 * @generated from protobuf message c1.api.settings.v1.BrandingConfiguration
 */
export interface BrandingConfiguration {
    /**
     * If enabled, returns computed logo/favicon. Otherwise, fields may be empty and clients should fallback.
     *
     * @generated from protobuf field: bool enabled = 1
     */
    enabled: boolean;
    /**
     * @generated from protobuf field: string display_name = 2
     */
    displayName: string;
    /**
     * @generated from protobuf field: c1.api.settings.v1.BrandingImage logo_white = 3
     */
    logoWhite?: BrandingImage; // Logo for dark backgrounds
    /**
     * @generated from protobuf field: c1.api.settings.v1.BrandingImage logo = 4
     */
    logo?: BrandingImage; // Logo for light backgrounds
    /**
     * @generated from protobuf field: c1.api.settings.v1.BrandingImage favicon = 5
     */
    favicon?: BrandingImage;
    /**
     * @generated from protobuf field: c1.api.settings.v1.BrandingImage favicon_white = 6
     */
    faviconWhite?: BrandingImage; // Favicon for dark backgrounds
}
/**
 * @generated from protobuf message c1.api.settings.v1.UpdateBrandingSettingsRequest
 */
export interface UpdateBrandingSettingsRequest {
    /**
     * @generated from protobuf field: c1.api.settings.v1.BrandingSettings branding_settings = 1
     */
    brandingSettings?: BrandingSettings;
    /**
     * @generated from protobuf field: google.protobuf.FieldMask update_mask = 2
     */
    updateMask?: FieldMask; // update name/enabled only
}
/**
 * @generated from protobuf message c1.api.settings.v1.UpdateBrandingSettingsResponse
 */
export interface UpdateBrandingSettingsResponse {
    /**
     * @generated from protobuf field: c1.api.settings.v1.BrandingConfiguration branding = 1
     */
    branding?: BrandingConfiguration;
}
/**
 * @generated from protobuf message c1.api.settings.v1.SetBrandingLogoRequest
 */
export interface SetBrandingLogoRequest {
    /**
     * @generated from protobuf field: bytes data = 1
     */
    data: Uint8Array;
}
/**
 * @generated from protobuf message c1.api.settings.v1.SetBrandingLogoResponse
 */
export interface SetBrandingLogoResponse {
    /**
     * @generated from protobuf field: c1.api.settings.v1.BrandingConfiguration branding = 1
     */
    branding?: BrandingConfiguration;
}
/**
 * @generated from protobuf message c1.api.settings.v1.SetBrandingLogoWhiteRequest
 */
export interface SetBrandingLogoWhiteRequest {
    /**
     * @generated from protobuf field: bytes data = 1
     */
    data: Uint8Array;
}
/**
 * @generated from protobuf message c1.api.settings.v1.SetBrandingLogoWhiteResponse
 */
export interface SetBrandingLogoWhiteResponse {
    /**
     * @generated from protobuf field: c1.api.settings.v1.BrandingConfiguration branding = 1
     */
    branding?: BrandingConfiguration;
}
/**
 * @generated from protobuf message c1.api.settings.v1.SetBrandingFaviconRequest
 */
export interface SetBrandingFaviconRequest {
    /**
     * @generated from protobuf field: bytes data = 1
     */
    data: Uint8Array;
}
/**
 * @generated from protobuf message c1.api.settings.v1.SetBrandingFaviconResponse
 */
export interface SetBrandingFaviconResponse {
    /**
     * @generated from protobuf field: c1.api.settings.v1.BrandingConfiguration branding = 1
     */
    branding?: BrandingConfiguration;
}
/**
 * @generated from protobuf message c1.api.settings.v1.SetBrandingFaviconWhiteRequest
 */
export interface SetBrandingFaviconWhiteRequest {
    /**
     * @generated from protobuf field: bytes data = 1
     */
    data: Uint8Array;
}
/**
 * @generated from protobuf message c1.api.settings.v1.SetBrandingFaviconWhiteResponse
 */
export interface SetBrandingFaviconWhiteResponse {
    /**
     * @generated from protobuf field: c1.api.settings.v1.BrandingConfiguration branding = 1
     */
    branding?: BrandingConfiguration;
}
/**
 * Public/unauthenticated view for pre-login and SSR consumption.
 *
 * @generated from protobuf message c1.api.settings.v1.IntrospectBrandingRequest
 */
export interface IntrospectBrandingRequest {
}
/**
 * @generated from protobuf message c1.api.settings.v1.IntrospectBrandingResponse
 */
export interface IntrospectBrandingResponse {
    /**
     * @generated from protobuf field: c1.api.settings.v1.BrandingConfiguration branding = 1
     */
    branding?: BrandingConfiguration;
}
/**
 * Tag-only ref for websocket notify / RTK invalidation.
 *
 * @generated from protobuf message c1.api.settings.v1.BrandingSettingsRef
 */
export interface BrandingSettingsRef {
}
// @generated message type with reflection information, may provide speed optimized methods
class BrandingImage$Type extends MessageType<BrandingImage> {
    constructor() {
        super("c1.api.settings.v1.BrandingImage", [
            { no: 1, name: "src", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "src_set", kind: "message", T: () => SrcSet }
        ]);
    }
    create(value?: PartialMessage<BrandingImage>): BrandingImage {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.src = "";
        if (value !== undefined)
            reflectionMergePartial<BrandingImage>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: BrandingImage): BrandingImage {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string src */ 1:
                    message.src = reader.string();
                    break;
                case /* c1.api.assets.v1.SrcSet src_set */ 2:
                    message.srcSet = SrcSet.internalBinaryRead(reader, reader.uint32(), options, message.srcSet);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: BrandingImage, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string src = 1; */
        if (message.src !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.src);
        /* c1.api.assets.v1.SrcSet src_set = 2; */
        if (message.srcSet)
            SrcSet.internalBinaryWrite(message.srcSet, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.settings.v1.BrandingImage
 */
export const BrandingImage = new BrandingImage$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BrandingSettings$Type extends MessageType<BrandingSettings> {
    constructor() {
        super("c1.api.settings.v1.BrandingSettings", [
            { no: 1, name: "enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<BrandingSettings>): BrandingSettings {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.enabled = false;
        message.displayName = "";
        if (value !== undefined)
            reflectionMergePartial<BrandingSettings>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: BrandingSettings): BrandingSettings {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool enabled */ 1:
                    message.enabled = reader.bool();
                    break;
                case /* string display_name */ 2:
                    message.displayName = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: BrandingSettings, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool enabled = 1; */
        if (message.enabled !== false)
            writer.tag(1, WireType.Varint).bool(message.enabled);
        /* string display_name = 2; */
        if (message.displayName !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.displayName);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.settings.v1.BrandingSettings
 */
export const BrandingSettings = new BrandingSettings$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BrandingConfiguration$Type extends MessageType<BrandingConfiguration> {
    constructor() {
        super("c1.api.settings.v1.BrandingConfiguration", [
            { no: 1, name: "enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "logo_white", kind: "message", T: () => BrandingImage },
            { no: 4, name: "logo", kind: "message", T: () => BrandingImage },
            { no: 5, name: "favicon", kind: "message", T: () => BrandingImage },
            { no: 6, name: "favicon_white", kind: "message", T: () => BrandingImage }
        ]);
    }
    create(value?: PartialMessage<BrandingConfiguration>): BrandingConfiguration {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.enabled = false;
        message.displayName = "";
        if (value !== undefined)
            reflectionMergePartial<BrandingConfiguration>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: BrandingConfiguration): BrandingConfiguration {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool enabled */ 1:
                    message.enabled = reader.bool();
                    break;
                case /* string display_name */ 2:
                    message.displayName = reader.string();
                    break;
                case /* c1.api.settings.v1.BrandingImage logo_white */ 3:
                    message.logoWhite = BrandingImage.internalBinaryRead(reader, reader.uint32(), options, message.logoWhite);
                    break;
                case /* c1.api.settings.v1.BrandingImage logo */ 4:
                    message.logo = BrandingImage.internalBinaryRead(reader, reader.uint32(), options, message.logo);
                    break;
                case /* c1.api.settings.v1.BrandingImage favicon */ 5:
                    message.favicon = BrandingImage.internalBinaryRead(reader, reader.uint32(), options, message.favicon);
                    break;
                case /* c1.api.settings.v1.BrandingImage favicon_white */ 6:
                    message.faviconWhite = BrandingImage.internalBinaryRead(reader, reader.uint32(), options, message.faviconWhite);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: BrandingConfiguration, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool enabled = 1; */
        if (message.enabled !== false)
            writer.tag(1, WireType.Varint).bool(message.enabled);
        /* string display_name = 2; */
        if (message.displayName !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.displayName);
        /* c1.api.settings.v1.BrandingImage logo_white = 3; */
        if (message.logoWhite)
            BrandingImage.internalBinaryWrite(message.logoWhite, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.settings.v1.BrandingImage logo = 4; */
        if (message.logo)
            BrandingImage.internalBinaryWrite(message.logo, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.settings.v1.BrandingImage favicon = 5; */
        if (message.favicon)
            BrandingImage.internalBinaryWrite(message.favicon, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.settings.v1.BrandingImage favicon_white = 6; */
        if (message.faviconWhite)
            BrandingImage.internalBinaryWrite(message.faviconWhite, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.settings.v1.BrandingConfiguration
 */
export const BrandingConfiguration = new BrandingConfiguration$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateBrandingSettingsRequest$Type extends MessageType<UpdateBrandingSettingsRequest> {
    constructor() {
        super("c1.api.settings.v1.UpdateBrandingSettingsRequest", [
            { no: 1, name: "branding_settings", kind: "message", T: () => BrandingSettings },
            { no: 2, name: "update_mask", kind: "message", T: () => FieldMask }
        ]);
    }
    create(value?: PartialMessage<UpdateBrandingSettingsRequest>): UpdateBrandingSettingsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateBrandingSettingsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateBrandingSettingsRequest): UpdateBrandingSettingsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.settings.v1.BrandingSettings branding_settings */ 1:
                    message.brandingSettings = BrandingSettings.internalBinaryRead(reader, reader.uint32(), options, message.brandingSettings);
                    break;
                case /* google.protobuf.FieldMask update_mask */ 2:
                    message.updateMask = FieldMask.internalBinaryRead(reader, reader.uint32(), options, message.updateMask);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateBrandingSettingsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.settings.v1.BrandingSettings branding_settings = 1; */
        if (message.brandingSettings)
            BrandingSettings.internalBinaryWrite(message.brandingSettings, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.FieldMask update_mask = 2; */
        if (message.updateMask)
            FieldMask.internalBinaryWrite(message.updateMask, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.settings.v1.UpdateBrandingSettingsRequest
 */
export const UpdateBrandingSettingsRequest = new UpdateBrandingSettingsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateBrandingSettingsResponse$Type extends MessageType<UpdateBrandingSettingsResponse> {
    constructor() {
        super("c1.api.settings.v1.UpdateBrandingSettingsResponse", [
            { no: 1, name: "branding", kind: "message", T: () => BrandingConfiguration }
        ]);
    }
    create(value?: PartialMessage<UpdateBrandingSettingsResponse>): UpdateBrandingSettingsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateBrandingSettingsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateBrandingSettingsResponse): UpdateBrandingSettingsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.settings.v1.BrandingConfiguration branding */ 1:
                    message.branding = BrandingConfiguration.internalBinaryRead(reader, reader.uint32(), options, message.branding);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateBrandingSettingsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.settings.v1.BrandingConfiguration branding = 1; */
        if (message.branding)
            BrandingConfiguration.internalBinaryWrite(message.branding, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.settings.v1.UpdateBrandingSettingsResponse
 */
export const UpdateBrandingSettingsResponse = new UpdateBrandingSettingsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SetBrandingLogoRequest$Type extends MessageType<SetBrandingLogoRequest> {
    constructor() {
        super("c1.api.settings.v1.SetBrandingLogoRequest", [
            { no: 1, name: "data", kind: "scalar", T: 12 /*ScalarType.BYTES*/ }
        ]);
    }
    create(value?: PartialMessage<SetBrandingLogoRequest>): SetBrandingLogoRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.data = new Uint8Array(0);
        if (value !== undefined)
            reflectionMergePartial<SetBrandingLogoRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SetBrandingLogoRequest): SetBrandingLogoRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bytes data */ 1:
                    message.data = reader.bytes();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SetBrandingLogoRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bytes data = 1; */
        if (message.data.length)
            writer.tag(1, WireType.LengthDelimited).bytes(message.data);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.settings.v1.SetBrandingLogoRequest
 */
export const SetBrandingLogoRequest = new SetBrandingLogoRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SetBrandingLogoResponse$Type extends MessageType<SetBrandingLogoResponse> {
    constructor() {
        super("c1.api.settings.v1.SetBrandingLogoResponse", [
            { no: 1, name: "branding", kind: "message", T: () => BrandingConfiguration }
        ]);
    }
    create(value?: PartialMessage<SetBrandingLogoResponse>): SetBrandingLogoResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<SetBrandingLogoResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SetBrandingLogoResponse): SetBrandingLogoResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.settings.v1.BrandingConfiguration branding */ 1:
                    message.branding = BrandingConfiguration.internalBinaryRead(reader, reader.uint32(), options, message.branding);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SetBrandingLogoResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.settings.v1.BrandingConfiguration branding = 1; */
        if (message.branding)
            BrandingConfiguration.internalBinaryWrite(message.branding, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.settings.v1.SetBrandingLogoResponse
 */
export const SetBrandingLogoResponse = new SetBrandingLogoResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SetBrandingLogoWhiteRequest$Type extends MessageType<SetBrandingLogoWhiteRequest> {
    constructor() {
        super("c1.api.settings.v1.SetBrandingLogoWhiteRequest", [
            { no: 1, name: "data", kind: "scalar", T: 12 /*ScalarType.BYTES*/ }
        ]);
    }
    create(value?: PartialMessage<SetBrandingLogoWhiteRequest>): SetBrandingLogoWhiteRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.data = new Uint8Array(0);
        if (value !== undefined)
            reflectionMergePartial<SetBrandingLogoWhiteRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SetBrandingLogoWhiteRequest): SetBrandingLogoWhiteRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bytes data */ 1:
                    message.data = reader.bytes();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SetBrandingLogoWhiteRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bytes data = 1; */
        if (message.data.length)
            writer.tag(1, WireType.LengthDelimited).bytes(message.data);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.settings.v1.SetBrandingLogoWhiteRequest
 */
export const SetBrandingLogoWhiteRequest = new SetBrandingLogoWhiteRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SetBrandingLogoWhiteResponse$Type extends MessageType<SetBrandingLogoWhiteResponse> {
    constructor() {
        super("c1.api.settings.v1.SetBrandingLogoWhiteResponse", [
            { no: 1, name: "branding", kind: "message", T: () => BrandingConfiguration }
        ]);
    }
    create(value?: PartialMessage<SetBrandingLogoWhiteResponse>): SetBrandingLogoWhiteResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<SetBrandingLogoWhiteResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SetBrandingLogoWhiteResponse): SetBrandingLogoWhiteResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.settings.v1.BrandingConfiguration branding */ 1:
                    message.branding = BrandingConfiguration.internalBinaryRead(reader, reader.uint32(), options, message.branding);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SetBrandingLogoWhiteResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.settings.v1.BrandingConfiguration branding = 1; */
        if (message.branding)
            BrandingConfiguration.internalBinaryWrite(message.branding, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.settings.v1.SetBrandingLogoWhiteResponse
 */
export const SetBrandingLogoWhiteResponse = new SetBrandingLogoWhiteResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SetBrandingFaviconRequest$Type extends MessageType<SetBrandingFaviconRequest> {
    constructor() {
        super("c1.api.settings.v1.SetBrandingFaviconRequest", [
            { no: 1, name: "data", kind: "scalar", T: 12 /*ScalarType.BYTES*/ }
        ]);
    }
    create(value?: PartialMessage<SetBrandingFaviconRequest>): SetBrandingFaviconRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.data = new Uint8Array(0);
        if (value !== undefined)
            reflectionMergePartial<SetBrandingFaviconRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SetBrandingFaviconRequest): SetBrandingFaviconRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bytes data */ 1:
                    message.data = reader.bytes();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SetBrandingFaviconRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bytes data = 1; */
        if (message.data.length)
            writer.tag(1, WireType.LengthDelimited).bytes(message.data);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.settings.v1.SetBrandingFaviconRequest
 */
export const SetBrandingFaviconRequest = new SetBrandingFaviconRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SetBrandingFaviconResponse$Type extends MessageType<SetBrandingFaviconResponse> {
    constructor() {
        super("c1.api.settings.v1.SetBrandingFaviconResponse", [
            { no: 1, name: "branding", kind: "message", T: () => BrandingConfiguration }
        ]);
    }
    create(value?: PartialMessage<SetBrandingFaviconResponse>): SetBrandingFaviconResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<SetBrandingFaviconResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SetBrandingFaviconResponse): SetBrandingFaviconResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.settings.v1.BrandingConfiguration branding */ 1:
                    message.branding = BrandingConfiguration.internalBinaryRead(reader, reader.uint32(), options, message.branding);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SetBrandingFaviconResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.settings.v1.BrandingConfiguration branding = 1; */
        if (message.branding)
            BrandingConfiguration.internalBinaryWrite(message.branding, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.settings.v1.SetBrandingFaviconResponse
 */
export const SetBrandingFaviconResponse = new SetBrandingFaviconResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SetBrandingFaviconWhiteRequest$Type extends MessageType<SetBrandingFaviconWhiteRequest> {
    constructor() {
        super("c1.api.settings.v1.SetBrandingFaviconWhiteRequest", [
            { no: 1, name: "data", kind: "scalar", T: 12 /*ScalarType.BYTES*/ }
        ]);
    }
    create(value?: PartialMessage<SetBrandingFaviconWhiteRequest>): SetBrandingFaviconWhiteRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.data = new Uint8Array(0);
        if (value !== undefined)
            reflectionMergePartial<SetBrandingFaviconWhiteRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SetBrandingFaviconWhiteRequest): SetBrandingFaviconWhiteRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bytes data */ 1:
                    message.data = reader.bytes();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SetBrandingFaviconWhiteRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bytes data = 1; */
        if (message.data.length)
            writer.tag(1, WireType.LengthDelimited).bytes(message.data);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.settings.v1.SetBrandingFaviconWhiteRequest
 */
export const SetBrandingFaviconWhiteRequest = new SetBrandingFaviconWhiteRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SetBrandingFaviconWhiteResponse$Type extends MessageType<SetBrandingFaviconWhiteResponse> {
    constructor() {
        super("c1.api.settings.v1.SetBrandingFaviconWhiteResponse", [
            { no: 1, name: "branding", kind: "message", T: () => BrandingConfiguration }
        ]);
    }
    create(value?: PartialMessage<SetBrandingFaviconWhiteResponse>): SetBrandingFaviconWhiteResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<SetBrandingFaviconWhiteResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SetBrandingFaviconWhiteResponse): SetBrandingFaviconWhiteResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.settings.v1.BrandingConfiguration branding */ 1:
                    message.branding = BrandingConfiguration.internalBinaryRead(reader, reader.uint32(), options, message.branding);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SetBrandingFaviconWhiteResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.settings.v1.BrandingConfiguration branding = 1; */
        if (message.branding)
            BrandingConfiguration.internalBinaryWrite(message.branding, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.settings.v1.SetBrandingFaviconWhiteResponse
 */
export const SetBrandingFaviconWhiteResponse = new SetBrandingFaviconWhiteResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class IntrospectBrandingRequest$Type extends MessageType<IntrospectBrandingRequest> {
    constructor() {
        super("c1.api.settings.v1.IntrospectBrandingRequest", []);
    }
    create(value?: PartialMessage<IntrospectBrandingRequest>): IntrospectBrandingRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<IntrospectBrandingRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: IntrospectBrandingRequest): IntrospectBrandingRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: IntrospectBrandingRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.settings.v1.IntrospectBrandingRequest
 */
export const IntrospectBrandingRequest = new IntrospectBrandingRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class IntrospectBrandingResponse$Type extends MessageType<IntrospectBrandingResponse> {
    constructor() {
        super("c1.api.settings.v1.IntrospectBrandingResponse", [
            { no: 1, name: "branding", kind: "message", T: () => BrandingConfiguration }
        ]);
    }
    create(value?: PartialMessage<IntrospectBrandingResponse>): IntrospectBrandingResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<IntrospectBrandingResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: IntrospectBrandingResponse): IntrospectBrandingResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.settings.v1.BrandingConfiguration branding */ 1:
                    message.branding = BrandingConfiguration.internalBinaryRead(reader, reader.uint32(), options, message.branding);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: IntrospectBrandingResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.settings.v1.BrandingConfiguration branding = 1; */
        if (message.branding)
            BrandingConfiguration.internalBinaryWrite(message.branding, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.settings.v1.IntrospectBrandingResponse
 */
export const IntrospectBrandingResponse = new IntrospectBrandingResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BrandingSettingsRef$Type extends MessageType<BrandingSettingsRef> {
    constructor() {
        super("c1.api.settings.v1.BrandingSettingsRef", []);
    }
    create(value?: PartialMessage<BrandingSettingsRef>): BrandingSettingsRef {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<BrandingSettingsRef>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: BrandingSettingsRef): BrandingSettingsRef {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: BrandingSettingsRef, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.settings.v1.BrandingSettingsRef
 */
export const BrandingSettingsRef = new BrandingSettingsRef$Type();
/**
 * @generated ServiceType for protobuf service c1.api.settings.v1.BrandingSettingsService
 */
export const BrandingSettingsService = new ServiceType("c1.api.settings.v1.BrandingSettingsService", [
    { name: "Update", options: { "authz.method": { role: "EDITOR" } }, I: UpdateBrandingSettingsRequest, O: UpdateBrandingSettingsResponse },
    { name: "SetBrandingLogo", options: { "authz.method": { role: "EDITOR" } }, I: SetBrandingLogoRequest, O: SetBrandingLogoResponse },
    { name: "SetBrandingLogoWhite", options: { "authz.method": { role: "EDITOR" } }, I: SetBrandingLogoWhiteRequest, O: SetBrandingLogoWhiteResponse },
    { name: "SetBrandingFavicon", options: { "authz.method": { role: "EDITOR" } }, I: SetBrandingFaviconRequest, O: SetBrandingFaviconResponse },
    { name: "SetBrandingFaviconWhite", options: { "authz.method": { role: "EDITOR" } }, I: SetBrandingFaviconWhiteRequest, O: SetBrandingFaviconWhiteResponse },
    { name: "Introspect", options: { "authz.method": { role: "REFLECTION" } }, I: IntrospectBrandingRequest, O: IntrospectBrandingResponse }
]);
